import Link, { linkClasses, LinkProps } from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography, {
  typographyClasses,
  TypographyProps,
} from '@mui/material/Typography';

export const FOOTER_HEIGHT = 40;

export const StyledFooter = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderTop: `1px solid ${theme.palette.divider}`,
  bottom: 0,
  height: FOOTER_HEIGHT,
  left: 0,
  position: 'fixed',
  right: 0,
  zIndex: theme.zIndex.drawer,
}));

export const StyledUl = styled('ul')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  height: '100%',
  justifyContent: 'center',
  listStyleType: 'none',
  margin: 0,
  padding: 0,
}));

export const StyledTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      color: theme.palette.text.primary,
    },
  }),
);

export const StyledLink = styled(Link)<LinkProps>(() => ({
  [`&.${linkClasses.root}`]: {
    textDecoration: 'none',
  },
}));
